module.exports = __webpack_public_path__ + "static/media/icon_menu_invoice.594436e6.svg";